module.exports = __webpack_public_path__ + "img/icon-ai-dark-blue.98e21f86.svg";